<template>
    <DModal
        is-confirm
        :title="__('tools.emails.messenger_app_modal.title')"
        :message="__('tools.emails.messenger_app_modal.message')"
        confirm-button-text="tools.emails.messenger_app_modal.configure_template"
        :show="show"
        @confirm="$emit('configure')"
        @close="$emit('close')"
    />
</template>

<script setup>
defineProps({
    show: {
        type: Boolean,
        default: false
    }
})
defineEmits(['configure', 'close'])
</script>
